import React from 'react'

import './country-label.scss'

export const CountryLabel = (props) => {
  const { id, euMember } = props
  return euMember && <span className='country-label'>{id}</span>
}
